module.exports = __webpack_public_path__ + "li.svg?75f00e3f44e3707a0f537c8c5538571b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/li.svg
// module id = 1055
// module chunks = 27